/** JavaScript 安全整数上限，雪花 ID 等 Long 值应始终以字符串传输 */
export const MAX_SAFE_INTEGER_DIGITS = String(Number.MAX_SAFE_INTEGER).length;

export function toIdString(value) {
  if (value == null || value === "") return null;
  const str = String(value).trim();
  return str || null;
}
